export function formatTime(intlShape, ...[value, formatOptions]) {
  return intlShape.formatTime(value, formatOptions);
}